import v8n from 'v8n'
import * as cnpj from '@fnando/cnpj'
import * as cpf from '@fnando/cpf'

const validations = {
  validCPForCNPJ: () => {
    return value => {
      if (value.length === 14) {
        return validations.validCPF()(value)
      } else {
        return validations.validCNPJ()(value)
      }
    }
  },
  validCPF: () => {
    return value => {
      return cpf.isValid(value) && value === cpf.format(value)
    }
  },
  validCNPJ: () => {
    return value => {
      return cnpj.isValid(value) && value === cnpj.format(value)
    }
  },
  validEmail: () => {
    return email => {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    }
  },
  validPhone: () => {
    return value => {
      const re = /^\([0-9]{2}\) [0-9]{4,5}-[0-9]{4}$/
      return re.test(String(value).toLowerCase())
    }
  }
}

v8n.extend(validations)
